import React from 'react'
import {Link, useMatch} from 'react-router-dom'
import * as c from '../../const'
import * as u from '../../utils'

const Logo = () => {
  const isHomePage = useMatch(c.LINK_HOME)

  const attr = {
    className: u.cls(`brand-logo`, {' --link': !isHomePage}),
    children: (
      <img
        className={`brand-logo`}
        src={require('../../assets/img/logo.png')}
        alt={c.SEO_TITLE_SUFFIX + ` Logo`}
      />
    )
  }

  if (!isHomePage) {
    return <Link to={c.LINK_HOME} {...attr} />
  }

  return <div {...attr} />
}

export default Logo